import React from 'react';
import {useIntl} from 'react-intl';

export default function NotFoundPage() {
  const {formatMessage} = useIntl()
  return <div>{formatMessage({id: 'app_gallery_not_found_page'})}</div>;
}
